/* eslint-disable no-use-before-define */

import React from 'react'
import YieldGrids from './yield-grids'
import ScatterGraph from './scatter-graph'
import Map from './map'
import MarketNews from './market-news'
import Tickers from './tickers'
import QuickScreener from './quick-screener'
import Resources from './resources'
import GreenBonds from './green-bonds'
import Education from './education'
import {trackPage} from '../twd'

export default () => {
    trackPage('municipals')

    return (
    <React.Fragment>

    <div className="container" style={{padding:0}}>
    <div className="row">
    <div className="col-md-12">
    <YieldGrids />
    </div>
    </div>
    </div>

    <div style={{backgroundColor:"#f6f6f6"}}>
    <div className="container">
    <div className="row vertical-offset-sm">

        <div className="col-md-8 col-xs-12">
            <ScatterGraph />
            <Map />
            <MarketNews />
            <Tickers />
        </div>

        <div className="col-md-4 col-xs-12">
            <QuickScreener />
            <Resources />
            <GreenBonds />
            <Education />
        </div>
    </div>
    </div>
    </div>
    </React.Fragment>)
}
